import React, { Component } from 'react';
import { BrowserRouter as Router, Route } from 'react-router-dom';

// Global components (header and footer)
import PageNavbar from './components/navs/PageNavbar';
import PageFooter from './components/navs/PageFooter';

// Page componenets
import HomePage from './components/home_page/HomePage';

// User related pages
import SignUpPage from './components/join_pages/SignUpPage';
import LoginPage from './components/join_pages/LoginPage';
import MyAccount from './components/user_pages/MyAccount';
import MySettings from './components/user_pages/MySettings';

// Software related pages
import SearchSoftwarePage from './components/home_page/SearchSoftwarePage';
import CreateSoftware from './components/software_pages/CreateSoftware';
import ViewSoftwarePage from './components/software_pages/ViewSoftwarePage';
import SoftwareReviews from './components/software_pages/SoftwareReviews';
import SoftwareQA from './components/software_pages/SoftwareQA';
import EditSoftwarePage from './components/software_pages/EditSoftwarePage';
import ForUsersPage from './components/about_pages/ForUsersPage';
import ForDevelopersPage from './components/about_pages/ForDevelopersPage';
import AboutPage from './components/about_pages/AboutPage';

// Bootstrap CSS file
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';

var firebase = require('firebase/app');
require('firebase/auth');
require('firebase/firestore');

// Use "exact" in Route to match exact path
class App extends Component {
  constructor(props) {
    super(props);

    this.loginUser = this.loginUser.bind(this);

    this.state = {
      isAuthenticated: false,
      noRender: true,
      userType: '',
      userName: '',
    };
  }

  componentDidMount() {
    let _this = this;
    firebase.auth().onAuthStateChanged(function (user) {
      if (user) {
        _this.setState({
          isAuthenticated: true,
          userType: 'user',
          userName: user.displayName,
        });
      } else {
        // NO user exists // TODO: Add to redirect page
        console.log('User not authenticated?');
        _this.setState({ isAuthenticated: false });
      }
      _this.setState({ noRender: false });
    });
  }

  loginUser(userType, userName) {
    this.setState({
      isAuthenticated: true,
      userType,
      userName,
    });
  }

  render() {
    return (
      <Router>
        <div className="App">
          <div className="App-header">
            <PageNavbar
              isAuthenticated={this.state.isAuthenticated}
              userName={this.state.userName}
              fixed="top"
            />
            <br />

            <Route
              path="/"
              exact
              render={props => (
                <HomePage
                  {...props}
                  isAuthenticated={this.state.isAuthenticated}
                  noRender={this.state.noRender}
                />
              )}
            />

            <Route
              path="/signup"
              render={props => (
                <SignUpPage 
                  {...props} 
                  loginUser={this.loginUser}
                  isAuthenticated={this.state.isAuthenticated} />
              )}
            />

            <Route
              path="/login"
              render={props => (
                <LoginPage 
                  {...props} 
                  loginUser={this.loginUser}
                  isAuthenticated={this.state.isAuthenticated} />
              )}
            />

            <Route
              path="/my_account"
              render={props => (
                <MyAccount
                  {...props}
                  userType={this.state.userType}
                  userName={this.state.userName}
                />
              )}
            />

            <Route
              path="/my_settings"
              render={props => (
                <MySettings
                  {...props}
                  userType={this.state.userType}
                  userName={this.state.userName}
                />
              )}
            />

            <Route path="/softie_home" component={SearchSoftwarePage} />
            <Route path="/create_product" component={CreateSoftware} />
            <Route path="/view_product/:id" component={ViewSoftwarePage} />
            <Route path="/edit_product/:id" component={EditSoftwarePage} />
            <Route path="/product_reviews/:id" component={SoftwareReviews} />
            <Route path="/product_qa/:id" component={SoftwareQA} />

            <Route path="/about" component={AboutPage} />
            <Route path="/users" component={ForUsersPage} />
            <Route path="/developers" component={ForDevelopersPage} />

            <PageFooter />
          </div>
        </div>
      </Router>
    );
  }
}

export default App;
